export const SET_IMPORT_OVERRIDE_CONFIG = 'SET_IMPORT_OVERRIDE_CONFIG';

type State = {
  overrideConfig: boolean;
  asnId: string | null;
};

export const actionMap = {
  [SET_IMPORT_OVERRIDE_CONFIG]: (state: State, { overrideConfig }: { overrideConfig: boolean }): State => {
    return {
      ...state,
      overrideConfig,
    };
  },
};

export const initialState: State = {
  overrideConfig: false,
  asnId: null,
};
